<script setup lang="ts">
import { UploadIcon } from "lucide-vue-next"
import { ref } from "vue"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

interface Props {
  accept?: string
  multiple?: boolean
  class?: string
}

const props = withDefaults(defineProps<Props>(), {
  accept: "*",
  multiple: false,
})

const emit = defineEmits<{
  change: [files: FileList | null]
}>()

const inputRef = ref<HTMLInputElement | null>(null)

const triggerFileDialog = () => {
  inputRef.value?.click()
}

const handleInputChange = (event: Event) => {
  const target = event.target as HTMLInputElement
  emit("change", target.files)
}
</script>

<template>
  <input
    ref="inputRef"
    type="file"
    :accept="accept"
    :multiple="multiple"
    class="hidden"
    @change="handleInputChange"
  />
  <Button
    type="button"
    :class="cn('cursor-pointer', props.class)"
    @click="triggerFileDialog"
  >
    <UploadIcon />
    Add new .xlsx
  </Button>
</template>
